module.exports = __webpack_public_path__ + "static/media/kake_blue-min.46da7e27.png";